import jStat from 'jstat';
import { round6 } from 'utilities/math';
import {
  GREATER_THAN_VALUE,
  LESS_THAN_VALUE
} from 'scenes/InferentialStatistics/Constants';

export const makeOneSidedPValue = zStat =>
  jStat.ztest(zStat, 1);

export const makeTwoSidedPValue = zStat =>
  jStat.ztest(zStat, 2);

export const makeProportionStDev = (p, n) => Math.sqrt((p * (1 - p)) / n);

export const getPHat = (successes, trials) => round6(Number(successes / trials));

export const makeProportionConfidenceLimits = (
  numberOfSuccess,
  numberOfTrials,
  confidenceInterval
) => {
  const populationProportion = numberOfSuccess / numberOfTrials;
  const confidenceLevel = 1 - ((1 - confidenceInterval) / 2);

  const standardError = makeProportionStDev(populationProportion, numberOfTrials);
  const zScore = jStat.normal.inv(confidenceLevel, 0, 1);

  const diff = Math.abs(zScore * standardError);

  const lowerLimit = populationProportion - diff;
  const upperLimit = populationProportion + diff;

  return { lowerLimit, upperLimit, standardError };
};

export const makeProportionHypothesizedProportion = (
  numberOfSuccess,
  numberOfTrials,
  hypothesisMean,
  alternativeHypothesis
) => {
  const populationProportion = numberOfSuccess / numberOfTrials;

  const standardError = makeProportionStDev(hypothesisMean, numberOfTrials);
  let tStatistics = (populationProportion - hypothesisMean) / standardError;

  if (!isFinite(tStatistics)) {
    tStatistics = 0;
  }

  let pValue = 0;

  switch (alternativeHypothesis) {
    case GREATER_THAN_VALUE:
      tStatistics > 0
        ? (pValue = makeOneSidedPValue(tStatistics))
        : (pValue = 1 - makeOneSidedPValue(tStatistics));
      break;
    case LESS_THAN_VALUE:
      tStatistics < 0
        ? (pValue = makeOneSidedPValue(tStatistics))
        : (pValue = 1 - makeOneSidedPValue(tStatistics));
      break;

    default:
      pValue = makeTwoSidedPValue(tStatistics);
  }

  return { h0: hypothesisMean, h1: hypothesisMean, pValue, tStatistics, standardError };
};

export const calculateTableDataForOneSampleProportion = (successes, trials, variable, levels, standardError) => {
  let variablesList = [];
  if (levels) {
    variablesList = [levels, ...variablesList];
  }
  if (variable) {
    variablesList = [variable, ...variablesList];
  }

  return [[...variablesList, trials, successes, getPHat(successes, trials), round6(standardError)]];
};
